var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCleanStarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 11.02L19.0702 8.10002L21.9902 7.02002L19.0702 5.94002L17.9902 3.02002L16.9002 5.94002L13.9902 7.02002L16.9002 8.10002L17.9902 11.02Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4602 12L15.2402 15.28L11.9702 16.5L15.2402 17.72L16.4602 20.99L17.6802 17.72L20.9602 16.5L17.6802 15.28L16.4602 12Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7401 9.26009L9.0001 4.59009L7.2701 9.26009L2.6001 11.0001L7.2701 12.7401L9.0101 17.4101L10.7501 12.7401L15.4201 11.0101L10.7501 9.27009L10.7401 9.26009ZM9.5701 11.5601L9.0001 13.0901L8.4301 11.5601L6.9001 10.9901L8.4301 10.4201L9.0001 8.89009L9.5701 10.4201L11.1001 10.9901L9.5701 11.5601Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCleanStarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clean_Star_Icon.00395d6c2aa43df9982990dd41993e57.svg";